import { render } from "./card2.vue?vue&type=template&id=1236fd76&scoped=true"
import script from "./card2.vue?vue&type=script&lang=js"
export * from "./card2.vue?vue&type=script&lang=js"

import "./card2.vue?vue&type=style&index=0&id=1236fd76&lang=scss&scoped=true"

import exportComponent from "/Users/baikaifa/Library/Containers/com.tencent.xinWeChat/Data/Documents/xwechat_files/wxid_1rhhjrwiu7uq22_9030/msg/file/2026-08/ubang-copilot-agents-web-deploy-2026-08-31/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1236fd76"]])

export default __exports__